import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../Components/Redux/store';
import { setAuth } from '../Components/Redux/authSlice';
import 'bootstrap/dist/css/bootstrap.min.css';

const ExpenseForm: React.FC = () => {
    const [expenseType, setExpenseType] = useState<string>('');
    const [cost, setCost] = useState<number | ''>('');
    const [datePaid, setDatePaid] = useState<string>('');
    const [errorMessage, setErrorMessage] = useState<string>('');
    const dispatch = useDispatch();
    const auth = useSelector((state: RootState) => state.auth.value);

    // Auto-fill current date on mount
    useEffect(() => {
        const now = new Date();
        const currentDate = now.toISOString().split('T')[0];
        setDatePaid(currentDate);
    }, []);

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        if (!expenseType || !cost || !datePaid) {
            setErrorMessage('Dhammaan meelaha waa loo baahan yahay');
            return;
        }

        try {
            const response = await axios.post<{ message: string }>('/fees/expenses/', {
                Expenses_type: expenseType,
                Cost: parseInt(cost as unknown as string),
                date_paid_expenses: datePaid
            });

            console.log('Expense created:', response.data);
            setExpenseType('');
            setCost('');
            setDatePaid('');
            setErrorMessage('');
            window.location.href = "/ExpenseList";
        } catch (error) {
            console.error('Error creating expense:', error);
            setErrorMessage('Khalad ayaa dhacay markii la abuurayay kharashka');
        }
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const token = getCookie('token');
                if (!token) {
                    dispatch(setAuth(false));
                    return;
                }

                axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
                await axios.get('/users/user');
                dispatch(setAuth(true));
            } catch (e) {
                dispatch(setAuth(false));
            }
        };
        fetchData();
    }, [dispatch]);

    const getCookie = (name: string) => {
        const cookieName = name + "=";
        const decodedCookie = decodeURIComponent(document.cookie);
        const cookieArray = decodedCookie.split(';');
        for (let i = 0; i < cookieArray.length; i++) {
            let cookie = cookieArray[i];
            while (cookie.charAt(0) === ' ') {
                cookie = cookie.substring(1);
            }
            if (cookie.indexOf(cookieName) === 0) {
                return cookie.substring(cookieName.length, cookie.length);
            }
        }
        return '';
    };

    return (
        <div className="container-fluid p-4 min-h-screen bg-gray-100 w-full md:ml-[200px] md:w-[calc(100%-200px)]">
            {auth ? (
                <div className="row justify-content-center mt-4 mt-md-5">
                    <div className="col-12 col-md-6 col-lg-5">
                        <div className="card shadow-lg border-0 rounded-lg">
                            <div className="card-body p-4 p-md-5">
                                <h2 className="card-title text-center mb-4 text-xl md:text-2xl font-bold text-gray-800">
                                    Diiwaangeli Kharash
                                </h2>
                                {errorMessage && (
                                    <div className="alert alert-danger alert-dismissible fade show" role="alert">
                                        {errorMessage}
                                        <button
                                            type="button"
                                            className="btn-close"
                                            onClick={() => setErrorMessage('')}
                                            aria-label="Close"
                                        ></button>
                                    </div>
                                )}
                                <form onSubmit={handleSubmit}>
                                    <div className="mb-3">
                                        <label htmlFor="expenseType" className="form-label font-semibold text-gray-700">
                                            Nooca Kharashka:
                                        </label>
                                        <input
                                            type="text"
                                            id="expenseType"
                                            className="form-control form-control-lg border-gray-300 focus:ring-blue-500 focus:border-blue-500"
                                            value={expenseType}
                                            onChange={(e) => setExpenseType(e.target.value)}
                                            placeholder="Geli nooca kharashka"
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="cost" className="form-label font-semibold text-gray-700">
                                            Qiimaha (KSh):
                                        </label>
                                        <input
                                            type="number"
                                            id="cost"
                                            className="form-control form-control-lg border-gray-300 focus:ring-blue-500 focus:border-blue-500"
                                            value={cost}
                                            onChange={(e) => setCost(parseFloat(e.target.value) || '')}
                                            placeholder="Geli qiimaha KSh"
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="datePaid" className="form-label font-semibold text-gray-700">
                                            Taariikhda:
                                        </label>
                                        <input
                                            type="date"
                                            id="datePaid"
                                            className="form-control form-control-lg border-gray-300 focus:ring-blue-500 focus:border-blue-500"
                                            value={datePaid}
                                            onChange={(e) => setDatePaid(e.target.value)}
                                            required
                                        />
                                        <small className="text-muted">Si toos ah u soo qaadanaya taariikhda maanta</small>
                                    </div>
                                    <div className="d-grid">
                                        <button
                                            type="submit"
                                            className="btn btn-primary btn-lg bg-blue-600 hover:bg-blue-700 transition-colors duration-200"
                                        >
                                            Gudbi
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <div className="text-center mt-5">
                    <h3 className="text-gray-600 text-lg md:text-xl">
                        Ma aadan xaqiijin ama awood uma lihid inaad aragto boggan
                    </h3>
                    <a href="/login" className="btn btn-primary mt-3">
                        Aad Login
                    </a>
                </div>
            )}
        </div>
    );
};

export default ExpenseForm;